import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentInsurancesRequest } from "../../../../../redux/inspection-firms/slice";
import { Card, Box, Typography, Divider } from "@mui/material";
import Loading from "../../../../../components/loading/loading";
import "./insurance.css";
import InsuranceDetails from "./insurance-details";

const Insurance = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCurrentInsurancesRequest());
  }, [dispatch]);

  const { loading, currentInsurances } = useSelector(
    (state: any) => state.inspectionFirms
  );

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Insurance</Typography>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">General Liability*</Typography>
          <InsuranceDetails
            data={{
              ...(currentInsurances?.filter(
                (item: any) => item.type === "GeneralLiability"
              )[0] || null),
            }}
          />
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Erros & Omissions* <br />
          </Typography>
          <InsuranceDetails
            data={{
              ...(currentInsurances?.filter(
                (item: any) => item.type === "GeneralLiability"
              )[0] || null),
            }}
          />
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Worker's Compensation* <br />
          </Typography>
          <InsuranceDetails
            data={{
              ...(currentInsurances?.filter(
                (item: any) => item.type === "GeneralLiability"
              )[0] || null),
            }}
          />
        </Box>
      </Card>
      {loading && <Loading />}
    </>
  );
};

export default Insurance;
